import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import terminology from 'javascripts/terminology';

export class EpicIcon extends Field {
  static availableForModel(modelClass, recordLayout) {
    if (!recordLayout.cardLayout?.epicsEnabled) return false;

    return super.availableForModel(modelClass, recordLayout);
  }

  static attributesForModel() {
    return ['epicId'];
  }

  get title() {
    return `${terminology('Epic')} icon`;
  }

  exampleContents(): FieldContentsData {
    return { icon: { name: 'aha-icon aha-icon-epic' } };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.epicId) {
      return { icon: { name: 'aha-icon aha-icon-epic' } };
    }

    return {};
  }
}
